import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet'; // Import Helmet
import WhatsAppButton from '../Components/WhatsAppButton';

const NotFoundPage = () => {
  return (
    <div className="bg-zinc-900 text-white min-h-screen flex flex-col items-center justify-center">
      {/* Start SEO Block */}
      <Helmet>
        <title>404 - Page Not Found | Brick and Clay</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {/* End SEO Block */}

      <h1 className="text-9xl font-bold text-accent-red">404</h1>
      <h2 className="text-4xl font-semibold mt-4">Page Not Found</h2>
      <p className="mt-2 text-lg text-neutral-300">
        Sorry, the page you are looking for does not exist.
      </p>
      <Link
        to="/"
        className="mt-8 inline-block bg-accent-red text-white font-bold uppercase tracking-widest py-3 px-8 rounded-sm hover:bg-red-700 transition-colors duration-300"
      >
        Go Home
      </Link>
      <WhatsAppButton />
    </div>
  );
};

export default NotFoundPage;